module.exports = __webpack_public_path__ + "img/graph-bar.6051e6f7.svg";